<template>
<v-content style="height: 100%;" class="px-0 mx-auto" :style="cssProps">
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>
        <v-col v-else id="details" md="12" style="height: 100%;" class="mt-0 pt-0" >
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'menu'})" icon x-large :color="$store.state.colors.primary" style="margin-left: 30px;">
                <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>
            <v-row justify="start" align="center"  class="pt-0">
                
                <img  :src="image == null ? require('@/assets/resources/yoomi/yoomy-screen.png'): image" style="width: 100%; height: 35vh; object-fit: cover; object-position: center;">

            </v-row>
            <v-row justify="start" align="center" style=" background-color: #e6e6e6;" class="pt-0">
                <br><br>
                <h3 class="Texto RestoBold">{{ titulo }}</h3>
            </v-row>
            <v-row justify="start" align="center" style="background-color: #e6e6e6;" class="pt-0">
                <hr style="border: 1.5px solid #4d4d4d; width:90%; margin-left: auto; margin-right: auto; border-radius: 7px 7px 7px 7px;">
            </v-row>
            <v-row justify="start" align="center" style=" background-color: #e6e6e6;" class="pt-0">
                <br>
                <p class="Texto-l RestoRegular">{{ descripcion }} </p>
            </v-row>
            <!-- Configuración de platillo
            <v-row justify="start" align="center" class="pt-0">
                <h2 class="Texto RestoBold">Configuración de platillo</h2>
            </v-row>
            <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0">
                <v-col justify="center" align="center">
                    <v-row justify="center" align="center" v-for="(i, index) in ingredientes" :key="index" style="margin: 0; padding: 0; padding-top: 0px; padding-bottom: 0px;">
                        <v-col cols="4" justify="center" align="center" style="padding-top: 0px; padding-bottom: 0px;">
                            <div style="overflow: hidden; "><v-btn icon large color="grey" style="padding-left: 0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_less.png" style="width:29px; height:29px;"></v-btn><span style="text-align: center;" class="RestoRegular">{{ i.contador }}</span><v-btn icon large color="grey" style="margin-left:0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_more.png" style="width:29px; height:29px;"></v-btn></div>
                        </v-col>
                        <v-col cols="8" :style="index%2 != 0 ? 'background-color:#e6e6e6;': ''" style="padding-top: 0px; padding-bottom: 0px;">
                            <v-row md="12">
                                <v-col xs="6" sm="6" md="6" lg="6" xl="6" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <p style="color:#4d4d4d position: relative; top: 5px;" class="RestoRegular">{{ i.nombre }}</p>
                                </v-col>
                                <v-col  xs="6" sm="6" md="6" lg="6" xl="6" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <p style="color:#4d4d4d position: relative; top: 5px;" class="RestoRegular">{{ i.precio }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row> -->
            <!-- Modificadores de cantidad-->
            <v-row justify="start" align="center" class="pt-0" v-if="ex_cantidad">
                <h2 class="Texto RestoBold">Elige hasta completar</h2>
            </v-row>
            <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0" v-if="ex_cantidad">
                <v-col justify="center" align="center">
                    <v-row justify="center" align="center" v-for="(i, index) in mod_cantidad" :key="index" style="margin: 0; padding: 0; padding-top: 0px; padding-bottom: 0px;">
                        <v-col cols="4" justify="center" align="center" style="padding-top: 0px; padding-bottom: 0px;">
                            <div style="overflow: hidden; "><v-btn :disabled="i.contador <= 0" class="btn-left" icon @click="menos(); i.contador--; cont_actual--; $store.state.counter_footerMUC0--;" large color="grey" style="padding-left: 0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_less.png" style="width:29px; height:29px;"></v-btn><span style="text-align: center;" class="RestoRegular">{{ i.contador }}</span><v-btn :disabled="cont_actual >= max_cont && max_cont!= 0 " class="btn-right" icon @click="mas(); i.contador++; cont_actual++; $store.state.counter_footerMUC0++;" large color="grey" style="margin-left:0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_more.png" style="width:29px; height:29px;"></v-btn></div>
                        </v-col>
                        <v-col cols="8" :style="index%2 != 0 ? 'background-color:#e6e6e6;': ''" style="padding-top: 0px; padding-bottom: 0px;">
                            <v-row md="12">
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <p style="color:#4d4d4d position: relative; top: 5px;" class="RestoRegular">{{ i.modificador }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- Modificadores múltiples -->
            <v-row justify="start" align="center" class="pt-0" v-if="ex_multiples">
                <h2 class="Texto RestoBold">Personaliza tu platillo</h2>
            </v-row>
            <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0" v-if="ex_multiples">
                <v-col justify="center" align="center">
                    <v-row justify="center" align="center" v-for="(i, index) in mod_multiples" :key="index" style="margin: 0; padding: 0;">
                        <v-col cols="4" justify="center" align="center" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <label class="container">
                                <input type="checkbox" :id="i.index" :value="i.estado" v-model="i.estado">
                                <span class="checkmark"></span>
                            </label>
                        </v-col>
                        <v-col cols="8" :style="index%2 != 0 ? 'background-color:#e6e6e6;': ''" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <p style="color:#4d4d4d;" class="RestoRegular">{{ i.modificador }}</p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- Modificadores únicos -->
            <v-row justify="center" align="center" v-for="(x, indexp) in mod_unicos" :key="indexp" style="margin: 0; padding: 0;">
                <v-col justify="center" align="center">
                    <v-row justify="start" align="center" class="pt-0" v-if="ex_unicos">
                        <h2 class="Texto RestoBold">Selecciona una opción</h2>
                    </v-row>
                    <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0" v-if="ex_unicos">
                        <v-col justify="center" align="center">
                            <v-row justify="center" align="center" v-for="(i, index) in x" :key="index" style="margin: 0; padding: 0;">
                                <v-col cols="4" justify="center" align="center" style="padding-top: 0px !important; padding-bottom: 0px !important; background-color: pink;">
                                    <label class="containerR">
                                        <input type="radio" @click="checkRadio(i.id_modificador,i.modificador,indexp)" :value="i.id_modificador" v-model="seleccion[indexp-1]">
                                        <span class="checkmarkR"></span>
                                    </label>
                                </v-col>
                                <v-col cols="8" :style="index%2 != 0 ? 'background-color:#e6e6e6;': ''" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <v-row md="12">
                                        <v-col xs="12" sm="12" md="12" lg="12" xl="12" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                            <p style="color:#4d4d4d" class="RestoRegular">{{ i.modificador }}</p>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- Adicionales -->
            <v-row justify="start" align="center" class="pt-0" v-if="ex_adicionales">
                <h2 class="Texto RestoBold">Adicionales</h2>
            </v-row>
            <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0" v-if="ex_adicionales">
                <v-col justify="center" align="center">
                    <v-row justify="center" align="center" v-for="(i, index) in adicionales" :key="index" style="margin: 0; padding: 0;">
                        <v-col cols="4" justify="center" align="center" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <div style="overflow: hidden; "><v-btn  :disabled="i.contador <= 0" class="btn-left" icon @click="i.contador--; restaAdicional(i.precio_adicional);" large color="grey" style="padding-left: 0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_less.png" style="width:29px; height:29px;"></v-btn><span style="text-align: center;" class="RestoRegular">{{ i.contador }}</span><v-btn class="btn-right" icon @click="i.contador++; sumaAdicional(i.precio_adicional);" large color="grey" style="margin-left:0px; width:29px; height:29px;"><img class='icon' src="@/assets/resources/icons/icon_value_more.png" style="width:29px; height:29px;"></v-btn></div>
                        </v-col>
                        <v-col cols="8" :style="index%2 != 0 ? 'background-color:#e6e6e6;': ''" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <v-row md="12">
                                <v-col xs="6" sm="6" md="6" lg="6" xl="6" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <p style="color:#4d4d4d" class="RestoRegular">{{ i.adicional }}</p>
                                </v-col>
                                <v-col  xs="6" sm="6" md="6" lg="6" xl="6" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                    <p style="color:#4d4d4d" class="RestoRegular">{{ i.precio_adicional }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- <v-card> -->
            <!-- <v-snackbar v-model="alert" class="font" style="z-index: 80;" :timeout="10000" :top="true" :app="true" :elevation="24" color="warning">
                Tu pedido no está completo
            </v-snackbar> -->
            <!-- </v-card> -->
            <!-- <v-row justify="center" align="center" style="background-color: #ffffff;" class="pt-0">
                <v-btn @click="go()"  class="text-left" color="#ff2846" dark x-large style="width: 90%; height: 65px; margin: 15px; "><span style="float: left; padding-left:0px;">Agregar a mi pedido</span><v-spacer></v-spacer><v-icon x-large>mdi-plus</v-icon></v-btn>
            </v-row>

            <v-row justify="center" align="center" style="background-color: #ffffff;" class="pt-0">
                <v-btn @click="go()"  class="text-left" color="#FF9030" dark x-large style="width: 90%; height: 65px; margin: 15px; "><span style="float: left; padding-left:0px;">Consultar complementos</span><v-spacer></v-spacer><v-icon x-large>mdi-plus</v-icon></v-btn>
            </v-row> -->

            <!-- <v-row justify="center" align="center" style=" background-color: #ffffff;" class="pt-0">
                <br><br><br>
                <v-container cols="12" style="border: 1px solid black; border-radius: 8px; width: 85%;">
                    <v-col cols="12">
                        <v-row xs="12" sm="12" md="12" lg="12" xl="12">
                            <h2 class="Texto-ll RestoBold">Comentarios</h2>
                        </v-row> 
                        <v-row xs="12" sm="12" md="12" lg="12" xl="12">
                            <hr style="border: 0.5px solid #4d4d4d; width:90%; margin-left: auto; margin-right: auto;">
                        </v-row> 
                        <v-row xs="12" sm="12" md="12" lg="12" xl="12">
                            <textarea id="w3mission" rows="4" style="width: 100%; margin-left: auto; margin-right: auto;">
                            </textarea>
                        </v-row> 
                        <v-row xs="12" sm="12" md="12" lg="12" xl="12">
                            <hr style="border: 0.5px solid #4d4d4d; width:90%; margin-left: auto; margin-right: auto;">
                        </v-row>  
                        <v-btn  class="text-left" :color="$store.state.colors.primary" dark x-large style="width: 50%; height: 50px; margin: 15px; float: right !important;"><span style="float: left; padding-left:0px;" class="RestoRegular">Guardar</span><v-spacer></v-spacer><v-icon >mdi-plus</v-icon></v-btn>
                    </v-col>
                </v-container>
            </v-row> -->
            <!-- <v-row justify="start" align="center"  class="pt-0">
                <br><br>
                <h2 class="Texto-r">Otros Usuarios</h2>
            </v-row>
            <v-row justify="start" align="center"  class="pt-0">
                <p class="Texto">Lo que otros usuarios recomiendan junto con este platillo </p>
            </v-row>
            <v-row style="max-width: 450px; margin: 0 auto">
                <v-col cols="4" v-for="(item, index) in menu" :key="index" >
                    <v-row justify="center">
                        <v-img @click="sendOption(item.name)" :style="'height: 130px; width: 130px;'" :src="require('@/assets/resources/menu/' + item.image)">
                            <v-row style="position: absolute; bottom: 5px; right: 0px; margin: 0 auto; width: 100%;" justify="end" class="pr-0">
                                <v-img max-width="24px" src="@/assets/resources/menu/icon_add.png"></v-img>
                            </v-row>
                        </v-img>
                    </v-row>
                    <v-row class="pt-0" style="font-size: 10px;" align="center">
                        <v-icon color="#ff2846" class="pr-1">mdi-information</v-icon>
                        {{item.name}}
                    </v-row>
                </v-col>
            </v-row> -->
        </v-col>
    </v-row>
</v-content>
</template>

<script>
  export default {
    data: () => ({
      image: "burritos",
      alert: false,
      id_platillo: null,
      vamosavercomoeselreinodelreves: 0,
      titulo: "",
      descripcion: "",
      mod_cantidad: [],
      mod_unicos: [],
      mod_multiples: [],
      adicionales: [],
      max_cont: 0,
      cont_actual:0,
      ex_cantidad: false,
      ex_unicos: false,
      ex_multiples: false,
      ex_adicionales: false,
      seleccion:[],
      nombreSeleccion: [],
      max_cont_uni: 0,
      cont_actual_uni: 0,
      validateLoad:true,
    }),
    methods: {
        go() {
            console.log("Going");
            this.$router.push({ name: 'address_register'})
        },
        sumaAdicional(precio_adicional){
            this.$store.state.precio_adicionales_footer += parseFloat(precio_adicional);
        },
        restaAdicional(precio_adicional){
            this.$store.state.precio_adicionales_footer -= parseFloat(precio_adicional);
        },
        menos(){
            if(this.max_cont == 0){
                this.$store.state.counter_footer--;
            }
        },
        mas(){
            if(this.max_cont == 0){
                this.$store.state.counter_footer++;
            }
        },
        checkRadio(id_modificador,modificador,indexpp){
            this.nombreSeleccion[indexpp-1]=modificador;
            if(this.seleccion[indexpp-1]==""){
                this.cont_actual_uni++;
            }
        }
    },
    created () {
        this.$store.state.details = true; 
        var exist = true;
        this.$store.dispatch("GET", {url: '/detalle_plat/'+this.$route.params.id_platillo, headers: {Authorization: this.$store.state.token}})
        // this.$store.dispatch("GET", {url: '/detalle_plat/520', headers: {Authorization: this.$store.state.token}})
            .then(response => {
                this.$store.state.modificators_flag = false;
                this.$store.state.precio_details_footer = response.data.precio;
                this.$store.state.counter_footer = 1;
                // console.log("EL RESPONSE: ",response.data);
                this.id_platillo = response.data.id_platillo;
                this.max_cont = parseInt(response.data.cantidad);
                this.$store.state.maxContValidation = this.max_cont;
                // console.log("MAXXXXXXX", this.$store.state.maxContValidation)
                // console.log(this.max_cont)
                if(this.max_cont == 0){
                    this.$store.state.counter_footer = 0;
                }
                this.titulo = response.data.platillo;
                this.descripcion = response.data.descripcion;
                this.image = response.data.imagen;
                if(response.data.modificadores != undefined){
                    // this.cont_actual = this.max_cont;
                    for(var mod = 0; mod < response.data.modificadores.length; mod++){
                        if(response.data.modificadores[mod].cantidad != undefined){
                            for (var i = 0; i < response.data.modificadores[mod].cantidad.length; i++) {
                                response.data.modificadores[mod].cantidad[i]["contador"] = 0;
                            }
                            this.mod_cantidad = response.data.modificadores[0].cantidad;
                            this.ex_cantidad = true;
                            exist = false;
                            this.$store.state.modificators_flag = true;
                            

                        }else if(exist){ 
                            this.cont_actual = this.max_cont;
                        }
                        if(response.data.modificadores[mod].unico != undefined && response.data.modificadores[mod].unico[0]!=null){
                            this.mod_unicos = response.data.modificadores[mod].unico[0];
                            this.ex_unicos = true;
                            for (var kk = 0; kk < Object.entries(this.mod_unicos).length; kk++) {
                                this.seleccion.push("");
                                this.nombreSeleccion.push(""); 
                                // response.data.modificadores[mod].cantidad[i]["contador"] = 0;
                            }
                            this.$store.state.modificators_flag = true;
                            this.max_cont_uni = Object.entries(this.mod_unicos).length;
                        }
                        if(response.data.modificadores[mod].multiple != undefined){
                            for (var j = 0; j < response.data.modificadores[mod].multiple.length; j++) {
                                response.data.modificadores[mod].multiple[j]["estado"] = false;
                            }
                            this.$store.state.modificators_flag = true;
                            this.mod_multiples = response.data.modificadores[mod].multiple;
                            this.ex_multiples = true;
                        }
                    }
                    // console.log("Actual",this.cont_actual)
                }
                else{
                    this.cont_actual = this.max_cont;
                }
                if(response.data.adicionales != undefined){
                        this.$store.state.modificators_flag = true;
                        console.log("Adicionales: ",response.data.adicionales);
                        for (var k = 0; k < response.data.adicionales.length; k++) {
                            response.data.adicionales[k]["contador"] = 0;
                        }
                        this.adicionales = response.data.adicionales;
                        this.$store.state.precio_adicionales_footer = 0;
                        this.ex_adicionales = true;
                }else{
                    this.$store.state.precio_adicionales_footer = 0;
                }
                this.validateLoad=false;
            })
            .catch(error => {
                console.log("Error: " + error);
                this.$router.push({ name: 'menu'});
            });
        // this.ingredientes = {...response.data};
    },
    beforeRouteLeave (to, from, next) {
        this.$store.state.details = false;
        next();
    },
    destroyed(){
        this.$root.$off('createOrder');
    },
    computed: {
        cssProps() {
            return {
                '--primary-color': this.$store.state.colors.primary
            }
        }
    },
    mounted() {
        this.$root.$on('createOrder', () => {
            // console.log("MAX_CONT ",this.max_cont);
            // console.log("CONT_ACTUAL ",this.cont_actual);
            // console.log("MAX_CONT_UNI ",this.max_cont_uni);
            // console.log("CONT_ACTUAL_UNI ",this.cont_actual_uni);
            if((this.max_cont == this.cont_actual && this.max_cont != 0 && this.cont_actual_uni == this.max_cont_uni) || (this.max_cont == 0 && this.cont_actual != 0 && this.cont_actual_uni == this.max_cont_uni)){
                var ad=[],mo=[];
                var ix;
                for(ix = 0; ix < this.mod_cantidad.length; ix++){
                    if(this.mod_cantidad[ix].contador!=0){
                        mo.push({id_modificador: this.mod_cantidad[ix].id_modificador, cantidad: this.mod_cantidad[ix].contador, nombre: this.mod_cantidad[ix].modificador});
                    }
                } 
                for(ix = 0; ix < this.seleccion.length; ix++){
                    mo.push({id_modificador: this.seleccion[ix], cantidad: 1, nombre: this.nombreSeleccion[ix]});
                } 
                // if(this.seleccion!=""){
                //     mo.push({id_modificador: this.seleccion, cantidad: 1, nombre: this.nombreSeleccion});
                // }
                for(ix = 0; ix < this.mod_multiples.length; ix++){
                    if(this.mod_multiples[ix].estado){
                        mo.push({id_modificador: this.mod_multiples[ix].id_modificador, cantidad: 1, nombre: this.mod_multiples[ix].modificador});
                    }
                } 
                for(ix = 0; ix < this.adicionales.length; ix++){
                    ad.push({id_adicional: this.adicionales[ix].id_adicional, cantidad: this.adicionales[ix].contador, precio_unitario: this.adicionales[ix].precio_adicional, nombre: this.adicionales[ix].adicional});
                } 
                var platillo = {
                    id_platillo: null,
                    titulo_platillo: null,
                    descripcion_platillo: null,
                    cantidad: null,
                    precio_unitario: null,
                    adicionales:[{
                        id_adicional: null,
                        cantidad: null,
                        precio_unitario: null,
                        nombre: null
                    }],
                    modificadores:[{
                        id_adicional: null,
                        cantidad: null,
                        nombre: null
                    }],
                }
                platillo.id_platillo = this.id_platillo;
                platillo.titulo_platillo = this.titulo;
                platillo.descripcion_platillo = this.descripcion;
                platillo.cantidad = this.$store.state.cantidad_footer;
                platillo.precio_unitario = this.$store.state.precio_details_footer;
                if(ad.length!=0){
                    platillo.adicionales = ad;
                }
                if(mo.length!=0){
                    platillo.modificadores = mo;
                }
                platillo.max_cant = this.max_cont;
                if(!this.$store.state.lista_platillos){
                    this.$store.dispatch('initilizePedido')
                }
                // console.log("EL OBJETO PLATILLO: ",this.$store.state.lista_platillos);
                this.$store.state.lista_platillos.push(platillo);
                localStorage.setItem('platillos', JSON.stringify(this.$store.state.lista_platillos));
                

                this.$router.push({ name: 'menu'});
            }else{
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Tu pedido no está completo";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
            }
        })
    }
  }
</script>

<style scoped>
    .btn-left:enabled {
        opacity: 1.0;
    }

    .btn-left:disabled {
        opacity: 0.3;
    }

    .btn-right:enabled {
        opacity: 1.0;
    }

    .btn-right:disabled {
        opacity: 0.3;
    }

  p{
    text-align: center;
    color: #4d4d4d;
  }
  h1{
    text-align: center;
    color: #4d4d4d;
  }
  .Texto{
      color: #4d4d4d;
      margin-left: 30px;
  }
  .Texto-r{
      color: #ff2846;
      margin-left: 30px;
  }
  .Texto-l{
      color: #4d4d4d;
      margin-left: 50px;
      text-align: left;
  }
  .Texto-ll{
      color: #4d4d4d;
      margin-left: 10px;
      text-align: left;
  }
  .hrcolor{
      border: 3px solid #4d4d4d;
  }

    /* The container */
    .container {
        position: relative;
        top: 15px;
        vertical-align: middle;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: relative;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e6e6e6;
        align-content: center;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        background-color: #e6e6e6; 
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: var(--primary-color);
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /* The container */
    .containerR {
        position: relative;
        vertical-align: middle;
        bottom: 15px;
        right: 15px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .containerR input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom radio button */
    .checkmarkR {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #e6e6e6;
        border-radius: 50%;
    }

    /* On mouse-over, add a grey background color */
    .containerR:hover input ~ .checkmarkR {
        background-color: #e6e6e6;
    }

    /* When the radio button is checked, add a blue background */
    .containerR input:checked ~ .checkmarkR {
        background-color: var(--primary-color);
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmarkR:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .containerR input:checked ~ .checkmarkR:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .containerR .checkmarkR:after {
        top: 9px;
        left: 9px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
    }
</style>